// extracted by mini-css-extract-plugin
module.exports = {"container":"label_container__dFOiQ","decorLine":"label_decorLine__JYH6v","large":"label_large__LAMVv","icon":"label_icon__jD52A","slide":"label_slide__F7a9J"};